import { TransformedLocaleConfig, LocaleName } from '../type';
const baseLocaleConfig = {
  name: 'he',
  months: ['ינואר', 'פברואר', 'מרץ', 'אפריל', 'מאי', 'יוני', 'יולי', 'אוגוסט', 'ספטמבר', 'אוקטובר', 'נובמבר', 'דצמבר'],
  monthsShort: ['ינואר', "פבר'", 'מרץ', 'אפריל', 'מאי', 'יוני', 'יולי', "אוג'", "ספט'", "אוק'", "נוב'", "דצמ'"],
  weekdays: ['יום ראשון', 'יום שני', 'יום שלישי', 'יום רביעי', 'יום חמישי', 'יום שישי', 'שבת'],
  weekdaysMin: ['א׳', 'ב׳', 'ג׳', 'ד׳', 'ה׳', 'ו׳', 'ש׳'],
  weekdaysShort: ['יום ראשון', 'יום שני', 'יום שלישי', 'יום רביעי', 'יום חמישי', 'יום שישי', 'שבת'],
  formats: {
    LT: 'HH:mm',
    LTS: 'HH:mm:ss',
    lt: 'HH:mm',
    lts: 'HH:mm:ss',
    L: 'YYYY.M.D',
    LL: 'D [ב]MMMM YYYY',
    'LL-D': 'MMMM YYYY',
    'LL-Y': 'D [ב]MMMM',
    LLL: 'D [ב]MMMM YYYY HH:mm',
    'LLL-Y': 'D [ב]MMMM HH:mm',
    LLLL: 'dddd, D [ב]MMMM YYYY HH:mm',
    'LLLL-Y': 'dddd, D [ב]MMMM HH:mm',
    l: 'YYYY.M.D',
    'l-Y': 'M.D',
    ll: 'D MMM YYYY',
    'll-Y': 'D MMM',
    lll: 'D MMM YYYY HH:mm',
    'lll-Y': 'D MMM HH:mm',
    llll: 'ddd, D MMM YYYY HH:mm',
    'llll-Y': 'ddd, D MMM HH:mm',
    'll-Y+w': 'ddd, D בMMM',
    'LT+to': 'H:mm ([GMT]Z[‎])',
    'LLL+to': 'D בMMMM YYYY, H:mm ([GMT]Z[‎])',
  },
  meridiem: { am: 'לפנה״צ', pm: 'אחה״צ', AM: 'לפנה״צ', PM: 'אחה״צ' },
  past: {
    y: { one: 'לפני שנה', two: 'לפני שנתיים', many: 'לפני %s שנה', other: 'לפני %s שנים' },
    M: { one: 'לפני חודש', two: 'לפני חודשיים', many: 'לפני %s חודשים', other: 'לפני %s חודשים' },
    w: { one: 'לפני שב׳', two: 'לפני שבועיים', many: 'לפני %s שב׳', other: 'לפני %s שב׳' },
    d: { one: 'אתמול', two: 'לפני יומיים', many: 'לפני %s ימים', other: 'לפני %s ימים' },
    h: { one: 'לפני שעה', two: 'לפני שעתיים', many: 'לפני %s שע׳', other: 'לפני %s שע׳' },
    m: { one: 'לפני דקה', two: 'לפני %s דק׳', many: 'לפני %s דק׳', other: 'לפני %s דק׳' },
    s: { one: 'לפני שנ׳', two: 'לפני שתי שנ׳', many: 'לפני %s שנ׳', other: 'לפני %s שנ׳' },
  },
  future: {
    y: { one: 'בעוד שנה', two: 'בעוד שנתיים', many: 'בעוד %s שנה', other: 'בעוד %s שנים' },
    M: { one: 'בעוד חודש', two: 'בעוד חודשיים', many: 'בעוד %s חודשים', other: 'בעוד %s חודשים' },
    w: { one: 'בעוד שב׳', two: 'בעוד שבועיים', many: 'בעוד %s שב׳', other: 'בעוד %s שב׳' },
    d: { one: 'מחר', two: 'בעוד יומיים', many: 'בעוד %s ימים', other: 'בעוד %s ימים' },
    h: { one: 'בעוד שעה', two: 'בעוד שעתיים', many: 'בעוד %s שע׳', other: 'בעוד %s שע׳' },
    m: { one: 'בעוד דקה', two: 'בעוד שתי דק׳', many: 'בעוד %s דק׳', other: 'בעוד %s דק׳' },
    s: { one: 'בעוד שנ׳', two: 'בעוד שתי שנ׳', many: 'בעוד %s שנ׳', other: 'בעוד %s שנ׳' },
  },
  abbr: {
    y: { one: 'שנה %s', two: 'שנתיים', many: '%s שנים', other: '%s שנים' },
    M: { one: 'חודש %s', two: 'חודשיים', many: '%s חודשים', other: '%s חודשים' },
    w: { one: 'שבוע %s', two: 'שבועיים', many: '%s שבועות', other: '%s שבועות' },
    d: { one: 'יום %s', two: 'יומיים', many: '%s ימים', other: '%s ימים' },
    h: { one: 'שעה %s', two: 'שעתיים', many: '%s שעות', other: '%s שעות' },
    m: { one: 'דקה %s', two: '%s דקות', many: '%s דקות', other: '%s דקות' },
    s: { one: 'שניה %s', two: '%s שניות', many: '%s שניות', other: '%s שניות' },
  },
  justNow: 'הרגע',
  yesterday: 'אתמול',
  today: 'היום',
  tomorrow: 'מחר',
  weekStart: 0,
};
const localeName: LocaleName = 'he';
export const localeConfig: TransformedLocaleConfig = {
  ...baseLocaleConfig,
  name: localeName,
  meridiem: (hour, _, isLowerCase = false): string => {
    if (hour < 12) {
      return isLowerCase ? 'לפנה״צ' : 'לפנה״צ';
    } else {
      return isLowerCase ? 'אחה״צ' : 'אחה״צ';
    }
  },
};
